import React, { useMemo } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import ProductGrid from './ProductGrid';
import { useAuth } from '../context/AuthContext';
import { useNoindexNofollow } from '../hooks/useNoindex';

export default function WishlistPage({ products, addToCart, wishlistIds, onToggleFav }) {
    useNoindexNofollow();
    const { isAuthenticated, loading } = useAuth();
    const navigate = useNavigate();

    const items = useMemo(() => {
        const favSet = wishlistIds instanceof Set
            ? wishlistIds
            : new Set(wishlistIds || []);
        return (products || []).filter((p) => favSet.has(String(p.id)));
    }, [products, wishlistIds]);

    if (loading) {
        return <div className="max-w-4xl mx-auto py-20 text-center text-gray-500">Загрузка…</div>;
    }

    if (!isAuthenticated) {
        return (
            <div className="max-w-md mx-auto py-20 text-center">
                <p className="text-gray-600 mb-4">Войдите, чтобы увидеть избранное</p>
                <Link to="/account/login" state={{ from: '/account/wishlist' }} className="btn-primary inline-block">
                    Войти
                </Link>
            </div>
        );
    }

    return (
        <div className="max-w-6xl mx-auto py-10 px-4">
            <nav className="text-xs text-gray-500 mb-4">
                <Link to="/account" className="hover:text-[#6B7A6A] hover:underline">Личный кабинет</Link>
                <span className="mx-1">/</span>
                <span className="text-[#1C1917]">Избранное</span>
            </nav>

            <h1 className="serif text-3xl text-[#1C1917] mb-3">Избранное</h1>
            <p className="text-gray-600 mb-8">
                {items.length === 0
                    ? 'Здесь пока пусто. Отмечайте товары сердечком — они сохранятся.'
                    : `Сохранено товаров: ${items.length}`}
            </p>

            {items.length === 0 ? (
                <div className="bg-[#F5F0EB] rounded-2xl p-8 text-center">
                    <p className="text-3xl mb-3">🖤</p>
                    <p className="text-gray-700 mb-4">Добавьте товары в избранное — вернётесь к ним позже</p>
                    <Link to="/" className="btn-primary inline-block">Перейти в каталог</Link>
                </div>
            ) : (
                <ProductGrid
                    products={items}
                    addToCart={addToCart}
                    onProductClick={(p) => navigate(`/product/${p.id}`)}
                    wishlistIds={wishlistIds}
                    onToggleFav={onToggleFav}
                />
            )}
        </div>
    );
}